import React from 'react';
import AddEditContactForm from 'ui-component/contact/AddEditContactForm';


function EditContact() {
  return (
    <div>
      <AddEditContactForm title="Edit Contact" />
    </div>
  );
}

export default EditContact;
